module.exports = __webpack_public_path__ + "img/2026big11.0e051269.png";